import React from 'react';

import { IWidgetGeneratorState } from '../..';
import Button from '../../../Button';
import ContextBubble from '../../../ContextBubble';
import { FormInputLabel } from '../../../Typography';
import { RowContainer } from '../../styled';
import { CodeContainer, CodeHighlight } from './styled';

interface IWidgetCodeGeneratorProps {
  options: IWidgetGeneratorState;
}

const widgetCodeCopy = 'The widget code automatically updates when any changes are made. Once you are happy with the preview of your widget, hit copy and paste that code into the required section of your website.';
const stateKeysToFilter = ['env', 'tempLogoUrl', 'width', 'height', 'activeTab'];

const WidgetCodeGenerator = (props: IWidgetCodeGeneratorProps) => {
  const { options } = props;
  const stateKeys = Object.keys(options).filter(key => !stateKeysToFilter.includes(key));

  const getFormattedStateKey = (key: string, index: number) => {
    if (key === 'apiKey') {
      return (
        <div>
          {`    "${key}":`}
          <CodeHighlight>{` "[YOUR API KEY]"`}</CodeHighlight>
          {`,`}
        </div>
      );
    } else {
      return (
        <div>
          {`    "${key}":`}
          <CodeHighlight>{`${JSON.stringify(options[key])}`}</CodeHighlight>
          {/* no comma if last item */}
          {index === stateKeys.length - 1 ? null : `,`}
        </div>
      );
    }
  };

  const copyToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerText = getStateForClipboard();
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  };

  const getStateForClipboard = () => {
    let clipboardString = `<script>
      WebChat.loadChat({
    `;
    stateKeys.forEach(key => {
      if (key === 'apiKey') {
        clipboardString += `"${key}": "[YOUR API KEY]",`;
      } else {
        clipboardString += `"${key}": ${JSON.stringify(options[key])},`;
      }

    });
    clipboardString = clipboardString.substring(0, clipboardString.length - 1);
    clipboardString += `});
      </script>
    `;
    return clipboardString;
  };

  return (
    <div>
      <RowContainer>
        <FormInputLabel bold>WIDGET CODE</FormInputLabel>
        <ContextBubble text={widgetCodeCopy} postitionLeft={-88} />
      </RowContainer>

      <CodeContainer>
        <div>
          {'<script>'}
        </div>
        <div>
          {'  WebChat.loadChat({'}
        </div>
        {stateKeys.map((key, index) => {
          return (
            <div key={key}>
              {getFormattedStateKey(key, index)}
            </div>
          );
        })}
        <div>
          {'  });'}
        </div>
        <div>
          {'</script>'}
        </div>
      </CodeContainer>
      <Button
        style={{ float: 'right' }}
        colorOverride={'#6277E2'}
        size='small'
        secondary
        onClick={() => copyToClipboard()}
      >
        Copy
      </Button>
    </div>
  );
};

export default WidgetCodeGenerator;
